/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Unlock_AriaInputs */



/**
* | output |
* | --- |
* | "Unlock" |
*
* @param {Explorer_Info_Unlock_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_unlock_aria = /** @type {((inputs?: Explorer_Info_Unlock_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Unlock_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Deverrouiller")
	if (locale === "de") return /** @type {LocalizedString} */ ("Entsperren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sbloccare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Разблокировать")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descubrir")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("开锁")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ロック解除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनलॉक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Desbloquear")
	return /** @type {LocalizedString} */ ("Unlock")
});